import React, { useEffect } from 'react';
import Layout from './Layout';
import '../styles/Pages.css';

interface ProductPagePlaceholderProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

const ProductPagePlaceholder: React.FC<ProductPagePlaceholderProps> = ({ title, description, icon }) => {
  useEffect(() => {
    document.title = `${title} | Personal Workspace`;
  }, [title]);

  return (
    <Layout>
      <div className="product-page-container fade-in">
        <div className="product-page-header-row">
          <div className="page-breadcrumb">
            <div className="page-breadcrumb-icon">{icon}</div>
            <h1 className="page-breadcrumb-title">{title}</h1>
          </div>
        </div>

        <div className="empty-state-container">
          <div className="empty-state-content">
            <div className="empty-state-icon">🚧</div>
            <h2>Coming soon</h2>
            <p>{description}</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProductPagePlaceholder;
